import Config from './../config';

function processRequest(request){
    let fullUrlRegExp = /^(https?:)\/\/(.*)$/;

    if(/^\/(.*)/.test(request.url)){
        request.url = request.url.replace('/', '');
    }

    if(!fullUrlRegExp.test(request.url.test)){
        let addSlash = request.url[0] !== '/' && Config.apiUrl.lastIndexOf('/') !== (Config.apiUrl.length - 1);
        request.url = Config.apiUrl + (addSlash ? '/' : '') + request.url;
    }

    return request;
}

function processResponse(Vue, response){
    return response;
}


export default {
    install: function(Vue, options){
        Vue.http.interceptors.push(function(request, next) {
            processRequest(request);

            next((response) => {
                return processResponse(Vue, response);
            });
        });

        // console.log(Vue.http.interceptor);

        // Vue.http.interceptor.before = function (request, next) {
        //     console.log("BEFORE FUNCTION");
        //     if (typeof request.before === 'function') {
        //         request.before.call(this, request);
        //     }
        //
        //     let fullUrlRegExp = /^(https?:)\/\/(.*)$/;
        //
        //     if(/^\/(.*)/.test(request.url)){
        //         request.url = request.url.replace('/', '');
        //     }
        //
        //     if(!fullUrlRegExp.test(request.url.test)){
        //         let addSlash = request.url[0] !== '/' && Config.apiUrl.lastIndexOf('/') !== (Config.apiUrl.length - 1);
        //         request.url = Config.apiUrl + (addSlash ? '/' : '') + request.url;
        //     }
        //     next();
        // };

        Vue.http.interceptors.json= (response) => {
            console.log('interceptors Json');
            return response;
        };
        Vue.http.interceptors.jsonp = (response) => {
            console.log('interceptors jsonp');
            return response;
        };
        Vue.http.interceptors.form = (response) => {
            console.log('interceptors form');
            return response;
        };
    }
}


// WEBPACK FOOTER //
// ./src/plugins/api.plugin.js